import * as types from './actionTypes';

const initialState = {
  familyMembers: [],
  currentFamilyMember: null,
  loading: false,
  success: false,
  error: null,
};

const familyMemberReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_FAMILY_MEMBERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_FAMILY_MEMBERS_SUCCESS:
      return {
        ...state,
        loading: false,
        familyMembers: action.payload,
      };
    case types.FETCH_FAMILY_MEMBERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.FETCH_FAMILY_MEMBER_REQUEST:
      console.log("types.FETCH_FAMILY_MEMBER_REQUEST");
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_FAMILY_MEMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        currentFamilyMember: action.payload,
      };
    case types.FETCH_FAMILY_MEMBER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Add family member
    case types.ADD_FAMILY_MEMBER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.ADD_FAMILY_MEMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        familyMembers: [...state.familyMembers, action.payload],
      };
    case types.ADD_FAMILY_MEMBER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Update family member
    case types.UPDATE_FAMILY_MEMBER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPDATE_FAMILY_MEMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        familyMembers: state.familyMembers.map((member) =>
          member.id === action.payload.id ? action.payload : member
        ),
      };
    case types.UPDATE_FAMILY_MEMBER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Delete family member
    case types.DELETE_FAMILY_MEMBER_REQUEST:
      console.log('DELETE_FAMILY_MEMBER_REQUEST');
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_FAMILY_MEMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        familyMembers: state.familyMembers.filter(
          (member) => member.id !== action.payload
        ),
      };
    case types.DELETE_FAMILY_MEMBER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.RESET_FAMILY_MEMBER:
      return {
        ...state,
        currentFamilyMember: null,
        success: false,
        error: null,
      };

    default:
      return state;
  }
};

export default familyMemberReducer;
